import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LockIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { useStore } from '../../context/StoreContext';
export function AdminLogin() {
  const navigate = useNavigate();
  const {
    login,
    user
  } = useStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  if (user?.isAdmin) {
    navigate('/admin/dashboard');
    return null;
  }
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('All fields are required');
      return;
    }
    const success = login(email, password);
    if (success && email === 'admin@skybrand.com') {
      navigate('/admin/dashboard');
    } else {
      setError('Invalid admin credentials');
    }
  };
  return <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-id="element-492">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-sm" data-id="element-493">
        <div className="text-center mb-8" data-id="element-494">
          <div className="w-16 h-16 bg-sky-600 rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-495">
            <ShieldIcon className="w-8 h-8 text-white" data-id="element-496" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-497">Admin Panel</h1>
          <p className="text-slate-400 text-sm mt-1" data-id="element-498">Sky Brand Management</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-800 rounded-2xl p-6 border border-slate-700 space-y-4" data-id="element-499">
          <div data-id="element-500">
            <label className="block text-sm font-medium text-slate-300 mb-1" data-id="element-501">
              Email
            </label>
            <div className="relative" data-id="element-502">
              <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" data-id="element-503" />
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-slate-700 border border-slate-600 rounded-lg text-sm text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500" placeholder="admin@skybrand.com" data-id="element-504" />
            </div>
          </div>
          <div data-id="element-505">
            <label className="block text-sm font-medium text-slate-300 mb-1" data-id="element-506">
              Password
            </label>
            <div className="relative" data-id="element-507">
              <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" data-id="element-508" />
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-slate-700 border border-slate-600 rounded-lg text-sm text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500" placeholder="Enter password" data-id="element-509" />
            </div>
          </div>
          {error && <p className="text-red-400 text-sm" data-id="element-510">{error}</p>}
          <button type="submit" className="w-full py-3 bg-sky-600 text-white font-semibold rounded-lg hover:bg-sky-700 transition-colors" data-id="element-511">
            Login as Admin
          </button>
          <p className="text-xs text-slate-500 text-center" data-id="element-512">
            admin@skybrand.com / admin123
          </p>
        </form>
      </motion.div>
    </div>;
}